export default {
  notifications: {
    unknownOutcome: 'The result is unconfirmed. Refresh or try again.',
    invitesSent: 'Group invites sent',
    createFailed: 'Failed to send group invites. Please try again.',
    inviteAcceptFailed: 'Failed to accept the group entry request. Please try again.',
    inviteDeclineFailed: 'Failed to decline the group entry request. Please try again.',
    groupCancelled: 'Group cancelled',
    groupCancelFailed: 'Failed to cancel the group. Please try again.',
  },
  bulkAccept: {
    title: 'Accept all group entry requests',
    count__hasPlural: {
      one: 'You have {{count}} open group entry request.',
      other: 'You have {{count}} open group entry requests.',
    },
    loading: 'Loading your requests…',
    kycRequired: 'Verify your identity on your account before accepting requests.',
    kycLoadError:
      'Identity status could not be loaded. Confirm your identity verification is complete, then reload this page.',
    loadError: 'Your group entry requests could not be loaded.',
    loadRetry: 'Try again',
    acceptAll: 'Accept All',
    accepting: 'Accepting {{done}} of {{total}}…',
    done: 'Done: {{accepted}} accepted, {{failed}} failed.',
    unknownContest: 'Unknown contest',
    sharePercent: '{{percent}}%',
    columns: {
      contest: 'Contest',
      organizer: 'Organizer',
      share: 'Share',
      cost: 'Cost',
      status: 'Status',
    },
    status: {
      pending: 'Pending',
      accepting: 'Accepting…',
      accepted: 'Accepted',
    },
    errors: {
      location: 'Location check failed.',
      http: 'Request failed (HTTP {{status}}).',
      network: 'Network error. The result is unconfirmed.',
      unexpectedStatus: 'Unexpected invite status: {{status}}.',
      unknown: 'Unknown error.',
    },
  },
  homeCard: {
    title: 'Group entry request',
    titlePlural: 'Group entry requests ({{count}})',
    wantsToJoin: '{{handle}} wants to play this entry with you',
    shareLabel: 'Share:',
    amountLabel: 'Amount:',
    locks: 'Locks',
    decline: 'Decline',
    accept: 'Join & pay {{amount}}',
  },
  acceptPage: {
    title: 'Join this group entry',
    subtitle: '{{handle}} wants to play this entry with you.',
    payTo: 'Pay to {{handle}}',
    organizerAvatar: 'Group entry organizer',
    unavailable: 'This group entry request is no longer available.',
    notRecipient: 'This group entry request was sent to a different account.',
    status: {
      paid: 'Paid',
      declined: 'Declined',
      cancelled: 'Cancelled',
    },
    accept: 'Join & pay {{amount}}',
    decline: 'Decline',
    kycError: 'Identity status could not be loaded.',
    kycRetry: 'Try again',
    loadError: 'This group entry request could not be loaded.',
    loadRetry: 'Try again',
    share: '{{percent}}% share',
    entryInfo: 'Entry info',
    pickControl: 'Makes the picks',
    pickControlTooltip: 'The pick controller makes the picks for this entry.',
    pickControlYou: 'You',
    // Suffix for a projected pick controller who has not paid/accepted in yet.
    pickControlPending: '(pending)',
    breakdown: 'Group members',
    people__hasPlural: {
      one: '{{count}} person',
      other: '{{count}} people',
    },
    expires: 'Join by',
    contestInfo: 'Contest info',
    entryFee: 'Entry fee',
    prizes: 'Prizes',
    contestPage: 'Contest page',
    viewContest: 'View contest',
    declineModal: {
      title: 'Decline group entry request?',
      description: 'The organizer will keep this share of the entry. This cannot be undone.',
      confirm: 'Decline request',
      cancel: 'Keep request',
    },
    confirmModal: {
      title: 'Confirm your share',
      shareOfEntry: '{{percent}}% of the {{entryFee}} entry',
      makesThePicks: 'Makes the picks',
      youWin: 'You win',
      youWinValue: '{{percent}}% of any payout',
      cashBalance: 'Cash Balance: {{amount}}',
      creditsBalance: 'Credits: {{amount}}',
      creditsAppliedFirst: 'Credits are applied first, then cash.',
      balanceLoading: 'Checking your balance…',
      balanceUnavailable: 'Balance unavailable',
      insufficientFunds: 'Insufficient funds',
      deposit: 'Deposit funds',
      pay: 'Pay {{amount}}',
    },
    verifyModal: {
      title: 'Verify your identity',
      body: 'Please complete identity verification on your account to proceed.',
      verifyNow: 'Verify now',
      notNow: 'Not now',
      staysOpen: "This invite stays open until {{expiry}}. We'll bring you right back here.",
    },
    successModal: {
      title: 'You are in',
      body: "You own {{percent}}% of {{handle}}'s entry in {{contest}}.",
      viewEntry: 'View entry',
    },
  },
  breakdownModal: {
    title: 'Group members',
    memberAvatar: 'Group member',
    loading: 'Loading group members',
    you: 'You',
    pickControl: 'Pick control',
    morePeople: '+{{count}} more',
    error: 'Group members could not be loaded. Please try again.',
  },
  panel: {
    back: 'Back',
    close: 'Close',
    title: 'Group entry',
    howItWorks: 'How group entries work?',
    groupWith: 'Choose your group',
    groupWithSubtitle: 'Select the players you want to share this entry with.',
    searchPlaceholder: 'SplashHandle',
    peopleYouFollow: 'People you follow',
    noFollowees: 'You are not following anyone yet.',
    noSearchResult: 'No user found for "{{query}}"',
    inviteLimitReached:
      'You can invite up to {{max}} people. Deselect someone to choose a different player.',
    continue: 'Continue',
    setUpGroup: 'Set everyone’s share',
    setUpGroupSubtitle: 'Choose how much of the entry each person will own and pay for.',
    setUpPickControl: 'Choose who makes the picks',
    pickControl: 'Pick control',
    organizerPickControl: 'You make the picks',
    setUpPickControlSubtitle: 'Select the person responsible for making picks for this entry.',
    entryFee: 'Entry fee',
    you: 'You',
    continueToPickControl: 'Continue',
    fiftyPercentError: '50% splits are not allowed',
    sumError: "Percentages can't add up to more than 100%",
    minimumShareError: 'Everyone needs at least 1%.',
    youWillLosePickControl: 'You will lose a pick control',
    groupEntry: 'Create group entry',
    invitesSent: 'Invites sent',
  },
  createPage: {
    loading: 'Loading',
    unavailable: 'This entry is unavailable right now.',
  },
  entryAction: {
    group: 'Group',
    cancelGroup: 'Cancel group',
    cancelPending: 'Cancel pending',
  },
  coachmark: {
    newBadge: 'NEW',
    title: 'Play this entry together',
    body: 'Tap Group to share the cost and compete together.',
    gotIt: 'Got it',
  },
  shareholders: {
    yourGroup: 'Your group',
    members__hasPlural: {
      one: '{{count}} member',
      other: '{{count}} members',
    },
    you: 'You',
    free: 'Free',
    pickControl: 'Pick control',
    makesThePicks: 'Makes the picks',
    pending: 'Pending',
    status: {
      pending: 'Waiting for payment',
      accepted: 'Paid',
      declined: 'Declined',
    },
  },
  cancelGroupModal: {
    title: 'Cancel group?',
    description:
      'All pending invites for this entry will be cancelled and you will keep full ownership of the entry.',
    cancel: 'Keep group',
    submit: 'Cancel group',
  },
  cancelPendingModal: {
    title: 'Cancel pending invites?',
    description:
      'Pending invitations will be cancelled. Members who already paid keep their shares.',
    cancel: 'Keep invites',
    submit: 'Cancel pending',
  },
};
